import {
  ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS,
  ELE_STATE_SUMMEARY_HAVE_ERROR,
  ELE_STATE_SUMMEARY_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actions
export function stateSummaryAction(action, payload) {
  switch (action) {
    case ELE_STATE_SUMMEARY_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case ELE_STATE_SUMMEARY_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function stateSummaryActionFetchData() {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(stateSummaryAction(ELE_STATE_SUMMEARY_ARE_LOADING, true));

      // Check if home primary data is available in local storage
      if (localStorage.getItem("SandeshElectionSummary")) {
        // If available, dispatch action with data from local storage
        dispatch(
          stateSummaryAction(
            ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS,
            JSON.parse(localStorage.getItem("SandeshElectionSummary")),
          ),
        );
      }

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(HttpService.EleStateSummary).then(
          (result) => {
            // Store fetched data in local storage
            localStorage.setItem("SandeshElectionSummary", JSON.stringify(result.data));
            // Dispatch action with fetched home primary data
            dispatch(stateSummaryAction(ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS, result.data));
            resolve(result);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          },
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(stateSummaryAction(ELE_STATE_SUMMEARY_HAVE_ERROR, true));
    }
  };
}
